'use strict';

var antd = require('./components');
var req = require.context('./components', true, /^\.\/locale-provider\/.+_.+\.tsx$/);

antd.locales = {};

req.keys().forEach(function (mod) {
  var match = mod.match(/\/([^/]+).tsx$/);
  antd.locales[match[1]] = req(mod);
});

module.exports = antd;


/*****************
 ** WEBPACK FOOTER
 ** ./index-with-locales.js
 ** module id = 0
 ** module chunks = 1
 **/